var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.065 17.755c-.7 0-1.33-.385-1.628-1.015L15.9 11.682l-.735 1.365a2.35 2.35 0 0 1-2.065 1.225h-1.278a1.322 1.322 0 0 1-1.312-1.312c0-.718.595-1.313 1.312-1.313h1.12l1.383-2.555c.332-.595.997-.997 1.627-.962.683 0 1.295.402 1.61.997l2.503 5.005.595-1.207a2.31 2.31 0 0 1 2.1-1.295h1.417c.718 0 1.313.595 1.313 1.312 0 .718-.595 1.313-1.313 1.313h-1.242l-1.243 2.467a1.786 1.786 0 0 1-1.627 1.033z",
    fill: "#F26F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.812 29.637A1.322 1.322 0 0 1 .5 28.325V18.35C.412 13.607 2.18 9.127 5.47 5.767c3.29-3.342 7.7-5.18 12.442-5.18C27.607.587 35.5 8.48 35.5 18.175v9.975c0 .717-.595 1.312-1.313 1.312a1.322 1.322 0 0 1-1.312-1.312v-9.975c0-8.243-6.703-14.963-14.963-14.963-4.042 0-7.787 1.558-10.57 4.393-2.8 2.852-4.287 6.65-4.217 10.71v9.992c0 .735-.578 1.33-1.313 1.33z",
    fill: "#F26F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.395 18.787h-.227A6.677 6.677 0 0 0 .5 25.455v3.29a6.677 6.677 0 0 0 6.668 6.667h.227a6.677 6.677 0 0 0 6.668-6.667v-3.29a6.677 6.677 0 0 0-6.668-6.668zM28.832 18.787h-.227a6.677 6.677 0 0 0-6.668 6.668v3.29a6.677 6.677 0 0 0 6.668 6.667h.227a6.677 6.677 0 0 0 6.668-6.667v-3.29a6.677 6.677 0 0 0-6.668-6.668z",
    fill: "#F26F4D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadphone);
export default __webpack_public_path__ + "static/media/icon_headphone.825a4309bd383e16c7cee5386e8979d7.svg";
export { ForwardRef as ReactComponent };